import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BotService } from '../../../_bot/_bot.service';

@Component({
    selector: 'reconnect-text',
    templateUrl: 'renderReconnectText.component.html'
})

export class RenderReconnectText {

    @Input() data: any;

    public submits = {
        buttons: [{
            type: "Action.OpenUrl",
            data: 'reload-bot',
            title: "Tentar reconectar.",
            // image: 'assets/images/icons/all-icons.svg#icon_ricochet_down'
        }]
    };

    constructor(
        private BotService: BotService
    ) { }

    reloadChat($event) {
        this.BotService.startConversation();
    }
}